import { button } from './button';
import { overlay } from './overlay';
import { CreateSessionFn, QuickstartBuilder, VippsBrandUnion } from './types';

const redirectTo = (url?: string) => {
  if (!url) return;

  if (window.top) {
    window.top.location.assign(url);
  } else {
    window.location.assign(url);
  }
};

export const quickstart = (createSession: CreateSessionFn): QuickstartBuilder => {
  if (typeof createSession !== 'function') {
    throw new Error('`quickstart` requires a createSession function that returns a payment URL.');
  }

  let brand: VippsBrandUnion = 'vipps';
  let domSelector: string | undefined;
  let buttonHandler: ReturnType<typeof button> | undefined;

  const overlayHandler = overlay(createSession)
    .on('success', (close, redirectUrl) => {
      close();
      redirectTo(redirectUrl);
    })
    .on('cancel', (close, redirectUrl) => {
      close();
      redirectTo(redirectUrl);
    });

  const mountInternal = (selector: string) => {
    buttonHandler?.unmount();
    buttonHandler = button().brand(brand).triggers(overlayHandler).mount(selector);
  };

  return {
    mount(selector: string) {
      domSelector = selector;
      mountInternal(selector);
      return this;
    },
    rerender() {
      if (domSelector) {
        mountInternal(domSelector);
      }

      return this;
    },
    unmount() {
      buttonHandler?.unmount();
      return this;
    },
    brand(value: VippsBrandUnion) {
      brand = value;

      if (domSelector) {
        mountInternal(domSelector);
      }

      return this;
    },
  };
};
